export default __webpack_public_path__ + "static/media/wifi.dd59bd5d.svg";